<template>
  <div class="media-view">
    <div class="sub-title">其他</div>
    <div class="media">
      <div
        class="imgbox imgbox1"
        v-if="mediaList[0].length > 0"
        @click="preview(mediaList[0])"
      >
        <div class="img-box">
          <img :src="mediaList[0][0]" alt="" />
          <div class="count">
            <i class="iconfont icon-tupian font-13"></i
            ><span>{{ mediaList[0].length }}</span>
          </div>
        </div>
        <span>胎压复位指示灯</span>
      </div>
      <div
        class="imgbox imgbox2"
        v-for="(item, index) in mediaList[1]"
        :key="item"
        @click="toPreviewVideo(item)"
      >
        <div class="img-box">
          <img src="@/assets/maintenance/tire-video-bg.png" alt="" />
        </div>
        <span>胎压复位指示灯视频{{ index + 1 }}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "media-view",
  components: {},
  data() {
    return {
      showVideo: false,
      showPop: false,
      curSrc: "",
    };
  },
  props: {
    mediaList: {
      type: Array,
    },
  },
  mounted() {
    // console.log(this.mediaList[1]);
  },
  methods: {
    toPreviewVideo(item) {
      this.$router.push({
        name: "view-video",
        query: {
          url: item,
        },
      });
    },
    preview(imgsArr, idx = 0) {
      this.$imagePreview({
        images: imgsArr,
        index: idx,
        defaultOpt: {
          fullscreenEl: false,
          arrowEl: true,
          preloaderEl: true,
          bgOpacity: 0.85,
          preload: [1, 1],
          showHideOpacity: true,
          showAnimationDuration: 0,
        },
      });
    },
    // previewVideo() {
    //   this.$router.push({
    //     name: "video-view",
    //     query: {
    //       src: "11",
    //     },
    //   });
    // },
  },
};
</script>
<style lang="less" scoped>
.media-view {
  background-color: #fff;
  // margin-top: 26/100rem;
  padding: 0 17/100rem;
  .fullscreenDialog {
    position: fixed;
    width: 100%;
    height: 100vh;
    left: 0;
    top: 0;
  }

  .sub-title {
    margin-top: 22/100rem;
    margin-bottom: 26/100rem;
    font-weight: 600;
    color: #404040;
    font-size: 27/100rem;
  }
  .media {
    display: flex;
    // justify-content: space-between;
    flex-wrap: wrap;
    margin-bottom: 46/100rem;
    .imgbox:first-child {
      margin-left: 0;
    }
    .imgbox {
      width: 188/100rem;
      height: auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      color: #404040;
      text-align: center;
      margin-left: 20/100rem;
      font-size: 20/100rem;
      .img-box {
        width: 100%;
        height: 188/100rem;
        border-radius: 9/100rem;
        overflow: hidden;
        border: 1px #f3f2f2 solid;
        margin-bottom: 17/100rem;
        position: relative;
        box-shadow: 0 3/100rem 20/100rem 0 rgba(0, 0, 0, 0.05);
        img {
          width: 100%;
          height: 188/100rem;
        }
        .count {
          background: rgba(0, 0, 0, 0.5);
          height: 31/100rem;
          padding: 2/100rem 9/100rem;
          color: #fff;
          font-size: 17/100rem;
          border-radius: 15/100rem;
          position: absolute;
          right: 9/100rem;
          bottom: 9/100rem;
          display: flex;
          align-items: center;
          i {
            margin-right: 2/100rem;
            font-size: 17/100rem;
            font-weight: 200;
          }
        }
      }
    }
  }
}
</style>
